export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/red-arrow-right-up.4cf7bca8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};